const METRICS = [
  ["detected", "Detected"],
  ["pending", "Pending"],
  ["ready", "Ready"],
  ["approved", "Approved"],
  ["blocked", "Blocked"],
  ["non_tradeable", "Non-Tradeable"],
];

export const SignalQueueSummary = ({ counts = {} }) => {
  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-5" data-testid="signal-queue-summary-card">
      <h3 className="text-base font-semibold text-slate-900" data-testid="signal-queue-summary-title">Signal Queue Summary</h3>
      <div className="mt-3 grid gap-2 sm:grid-cols-2 lg:grid-cols-3" data-testid="signal-queue-summary-grid">
        {METRICS.map(([key, label]) => (
          <article key={key} className="rounded-xl border border-slate-200 bg-slate-50 p-3" data-testid={`signal-queue-summary-item-${key}`}>
            <p className="text-xs uppercase tracking-wider text-slate-500" data-testid={`signal-queue-summary-label-${key}`}>{label}</p>
            <p className="text-lg font-semibold text-slate-900" data-testid={`signal-queue-summary-value-${key}`}>{Number(counts?.[`${key}_count`] ?? counts?.[key] ?? 0)}</p>
          </article>
        ))}
      </div>
    </section>
  );
};
